import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { hasClass } from '../../../libs/gin-tonic/helpers/dom/has-class/index';
import { removeClass } from '../../../libs/gin-tonic/helpers/dom/remove-class/index';
import { toggleClass } from '../../../libs/gin-tonic/helpers/dom/toggle-class/index';

@Component({ className: 'js-sidebar' })
export class SidebarComponent {
	constructor(public element: HTMLElement) {
		var triggers = Array.from(element.querySelectorAll('.js-sidebar-trigger')) as HTMLElement[];
		if (triggers && triggers.length > 0) {
			triggers.forEach(trigger => {
				trigger.addEventListener('click', () => {
					toggleClass(this.element, 'is-active');
					toggleClass(document.body, 'has-backdrop');
				});
			});
		}
		document.addEventListener('click', e => {
			if (!e.target.closest('.js-sidebar') && hasClass(document.body, 'has-backdrop')) {
				removeClass(this.element, 'is-active');
				removeClass(document.body, 'has-backdrop');
			}
		});
	}
}
